import React from "react";
import { useEnvironment } from "../hooks/useEnvironment";

export const EnvironmentInfo: React.FC = () => {
  const env = useEnvironment();

  if (!env.isDevelopment) {
    return null; // Don't show in production
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        backgroundColor: env.environment === "dev" ? "#4CAF50" : "#FF9800",
        color: "white",
        padding: "4px 8px",
        fontSize: "12px",
        fontFamily: "monospace",
        zIndex: 9999,
        borderRadius: "0 0 0 4px",
      }}
    >
      {env.environment.toUpperCase()}
    </div>
  );
};

export const EnvironmentDebugPanel: React.FC = () => {
  const env = useEnvironment();
  const [isVisible, setIsVisible] = React.useState(true);

  if (!env.isDevelopment || !isVisible) {
    return null; // Don't show in production or if closed
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "white",
        padding: "10px",
        fontSize: "11px",
        fontFamily: "monospace",
        maxWidth: "300px",
        zIndex: 9999,
        borderRadius: "0 4px 0 0",
      }}
    >
      <button
        onClick={() => setIsVisible(false)}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          background: "transparent",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontSize: "16px",
          lineHeight: "16px",
          padding: "0",
          width: "16px",
          height: "16px",
        }}
        title="Close"
      >
        ×
      </button>
      <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
        Environment: {env.environment}
      </div>
      <div>Bundle ID: {env.bundleId}</div>
      <div>Extension ID: {env.extensionId}</div>
      <div>Server ID: {env.serverId}</div>
      <div>Port: {env.port}</div>
      <div>
        Debug Ports: {env.debugPorts.extension}/{env.debugPorts.server}
      </div>
    </div>
  );
};
